<template>
  <div class="container">
    <div v-for="(item, index) in settingList">
      <SettingItem :item="item"/>
    </div>
  </div>
</template>

<script>

import TitleBarStore from '@/components/widgets/TitleBarStore'
import SettingItem from '@/components/widgets/SettingItem'
import app from '@/AppData'
import Constants from '@/components/setting/Constants'
import jsbridge from '@/jsbridge'
import lubanapi from '@/lubanapi'

export default {

  name: 'VipRefusePage',

  components: {
    SettingItem
  },

  data () {
    let that = this
    return {
      settingList: [
        // {
        //   divider: true,
        //   bgColor: '#FAFAFA',
        //   height: 0.8,
        // },
        {
          isTitleItem: true,
          titleIcon: '@/../static/refuse_question_icon.png',
          title: '开启后，以下场景助理将直接回复“不需要，谢谢”并挂断电话',
        },
        {
          icon: '@/../static/refuse_house_icon.png',
          title: '谢绝房产中介',
          isSwitch: true,
          switch: that.checkSceneRefuse(Constants.SCENE_KEY.HOUSE),
          switchTouch: app.isVip(),
          onClick: function () {
            console.log(this.title)
            that.onSwitchClick(Constants.SCENE_KEY.HOUSE, 0)
          }
        },
        {
          divider: true,
          bgColor: '#FAFAFA',
          height: 0.1
        },
        {
          icon: '@/../static/refuse_finance_icon.png',
          title: '谢绝理财推销',
          isSwitch: true,
          switch: that.checkSceneRefuse(Constants.SCENE_KEY.FINANCE),
          switchTouch: app.isVip(),
          onClick: function () {
            console.log(this.title)
            that.onSwitchClick(Constants.SCENE_KEY.FINANCE, 1)
          }
        },
        {
          divider: true,
          bgColor: '#FAFAFA',
          height: 0.1
        },
        {
          icon: '@/../static/refuse_edu_icon.png',
          title: '谢绝教育产品推销',
          isSwitch: true,
          switch: that.checkSceneRefuse(Constants.SCENE_KEY.COURSE),
          switchTouch: app.isVip(),
          onClick: function () {
            console.log(this.title)
            that.onSwitchClick(Constants.SCENE_KEY.COURSE, 2)
          }
        },
        {
          divider: true,
          bgColor: '#FAFAFA',
          height: 0.1
        },
        {
          icon: '@/../static/refuse_hunt_icon.png',
          title: '谢绝猎头',
          isSwitch: true,
          switch: that.checkSceneRefuse(Constants.SCENE_KEY.HUNTING),
          switchTouch: app.isVip(),
          onClick: function () {
            console.log(this.title)
            that.onSwitchClick(Constants.SCENE_KEY.HUNTING, 3)
          }
        },
        {
          divider: true,
          bgColor: '#FAFAFA',
          height: 0.1
        },
        {
          icon: '@/../static/refuse_loan_icon.png',
          title: '谢绝贷款中介',
          isSwitch: true,
          switch: that.checkSceneRefuse(Constants.SCENE_KEY.LOAN),
          switchTouch: app.isVip(),
          onClick: function () {
            console.log(this.title)
            that.onSwitchClick(Constants.SCENE_KEY.LOAN, 4)
          }
        },
        {
          divider: true,
          bgColor: '#FAFAFA',
          height: 0.1
        },
        {
          icon: '@/../static/refuse_insurance_icon.png',
          title: '谢绝保险推销',
          isSwitch: true,
          switch: that.checkSceneRefuse(Constants.SCENE_KEY.INSURANCE),
          switchTouch: app.isVip(),
          onClick: function () {
            console.log(this.title)
            that.onSwitchClick(Constants.SCENE_KEY.INSURANCE, 5)
          }
        },
        {
          divider: true,
          bgColor: '#FAFAFA',
          height: 0.1
        }
      ]
    }
  },

  methods: {

    checkSceneRefuse (key) {
      if (!app.isVip()) {
        return false
      }
      if (!app.getData().sceneReplySettings[key]) {
        return false
      }
      return true
    },

    onSwitchClick (key, index) {
      if (!app.isVip()) {
        // 非会员
        jsbridge.showVipGuideDialog(this)
        return
      }
      let value = app.getData().sceneReplySettings[key]
      if (value) {
        app.getData().sceneReplySettings[key] = ''
        lubanapi.reportseer('AICall_Decline_Scene_Setting_Page_Switch_Operation', app.isVip() ? '1' : '0', JSON.stringify(index), '1')
      } else {
        app.getData().sceneReplySettings[key] = Constants.REFUSE_REPLY
        lubanapi.reportseer('AICall_Decline_Scene_Setting_Page_Switch_Operation', app.isVip() ? '1' : '0', JSON.stringify(index), '0')
      }
      // 先刷新UI

      app.updateSceneReply().then(value => {
        console.log('updateSceneReply success')
        console.log(value)
      }, reason => {
        console.log('updateSceneReply fail')
        console.log(JSON.stringify(reason))
      })
    }
  },

  mounted () {
    TitleBarStore.store.showvipicon()
    lubanapi.reportseer('AICall_Decline_Scene_Setting_Page_Shown', app.isVip() ? '1' : '0')
  }

}

</script>

<style scoped>


.container {
  width: 100%;
  height: 100%;
  background-color: #FAFAFA;
}

</style>



// WEBPACK FOOTER //
// src/components/setting/VipRefusePage.vue